<template>
  <div class="star-block">
    <div class="title-wrap">
      <div class="tab-list">
        <div
          :class="[tabLabel == 1 ? 'activity active' : 'activity']"
          @click="changeLabel(1)"
        >
          <div class="content">活动页面</div>
        </div>
        <div
          :class="[tabLabel == 2 ? 'product active' : 'product']"
          @click="changeLabel(2)"
        >
          <div class="content">作品数据</div>
        </div>
      </div>
    </div>
    <star-content v-if="tabLabel == 1"> </star-content>
    <product-data v-else> </product-data>
  </div>
</template>
<script>
import starContent from './components/starContent.vue';
import productData from './components/productData.vue';
import { mapState } from 'vuex';
import { logUrl } from '@/api/logUrl.js';
export default {
  data() {
    return {
      tabLabel: 1,
    };
  },
  mounted() {
    this.init();
  },
  components: {
    starContent,
    productData,
  },
  beforeDestroy() {
    this.$store.commit('SET_BACKLABEL', 0);
  },
  computed: {
    ...mapState(['backLabel']),
  },
  methods: {
    init() {
      this.logPage();
      if (this.backLabel == 1) {
        this.tabLabel = 2;
      } else {
        this.tabLabel = 1;
      }
    },
    changeLabel(id) {
      this.tabLabel = id;
    },
    // 曝光埋点
    logPage() {
      let data = {
        ts: Math.floor(new Date().getTime() / 1000),
        product: 71005,
        id: 71005,
        event_type: 'view',
        activity: 10024,
        scene_comp: 'StarPlan_Page',
      };
      logUrl(data);
    },
  },
};
</script>
<style lang="scss" scoped>
$--color-primary: #fd9b21;
.title-wrap {
  .tab-list {
    display: flex;
    color: #595959;
    font-size: 18px;
    border-bottom: 1px solid #d9d9d9;
    .activity {
      font-size: 20px;
      font-family: MicrosoftYaHei;
      padding-bottom: 10px;
      margin-right: 19px;
      cursor: pointer;
      .content {
        line-height: 26px;
        -webkit-background-clip: text;
      }
    }
    .activity.active {
      border-bottom: 4px solid #fd9b21;
      position: relative;
      color: #fd9b21;
      &:before {
        display: block;
        content: '';
        width: 0;
        border-width: 4px;
        border-style: solid;
        border-color: transparent transparent $--color-primary transparent;
        position: absolute;
        left: 50%;
        margin-left: -2px;
        bottom: 0;
      }
    }
    .product {
      padding-bottom: 10px;
      font-size: 20px;
      cursor: pointer;
      line-height: 26px;
      -webkit-background-clip: text;
      //-webkit-text-fill-color: transparent;
    }
    .product.active {
      border-bottom: 4px solid #fd9b21;
      position: relative;
      color: #fd9b21;
      &:before {
        display: block;
        content: '';
        width: 0;
        border-width: 4px;
        border-style: solid;
        border-color: transparent transparent $--color-primary transparent;
        position: absolute;
        left: 50%;
        margin-left: -2px;
        bottom: 0;
      }
    }
  }
}
</style>
